import angular from 'angular';

import { r2a } from '@/react-tools/react2angular';
import { withCurrentUser } from '@/react-tools/withCurrentUser';
import { withReactQuery } from '@/react-tools/withReactQuery';
import { withUIRouter } from '@/react-tools/withUIRouter';
import { AutoUpdateFieldset } from '@/react/portainer/gitops/AutoUpdateFieldset';
import { GitForm } from '@/react/portainer/gitops/GitForm';
import { AuthFieldset } from '@/react/portainer/gitops/AuthFieldset';
import { RefField } from '@/react/portainer/gitops/RefField';
import { TimeWindowDisplay } from '@/react/portainer/gitops/TimeWindowDisplay';
import { GitReferenceCard } from '@/react/portainer/gitops/GitReferenceCard';

export const gitFormModule = angular
  .module('portainer.app.components.forms.git', [])
  .component(
    'reactGitForm',
    r2a(withUIRouter(withReactQuery(withCurrentUser(GitForm))), [
      'value',
      'onChange',
      'environmentType',
      'isDockerStandalone',
      'deployMethod',
      'isAdditionalFilesFieldVisible',
      'isForcePullVisible',
      'isAuthExplanationVisible',
      'errors',
      'baseWebhookUrl',
      'webhookId',
      'webhooksDocs',
      'createdFromCustomTemplateId',
      'isAutoUpdateVisible',
    ])
  )

  .component(
    'gitFormGitReferenceCard',
    r2a(withReactQuery(GitReferenceCard), [
      'stackId',
      'stackType',
      'gitConfig',
      'autoUpdate',
      'currentDeploymentInfo',
    ])
  )
  .component(
    'reactGitFormAutoUpdateFieldset',
    r2a(withUIRouter(withReactQuery(AutoUpdateFieldset)), [
      'value',
      'onChange',
      'environmentType',
      'deployMethod',
      'isForcePullVisible',
      'errors',
      'baseWebhookUrl',
      'webhookId',
      'webhooksDocs',
    ])
  )
  .component(
    'reactGitFormAuthFieldset',
    r2a(withUIRouter(withReactQuery(withCurrentUser(AuthFieldset))), [
      'value',
      'isAuthExplanationVisible',
      'onChange',
      'errors',
    ])
  )
  .component(
    'reactGitFormRefField',
    r2a(withUIRouter(withReactQuery(withCurrentUser(RefField))), [
      'error',
      'model',
      'onChange',
      'stackId',
      'createdFromCustomTemplateId',
      'value',
      'isUrlValid',
    ])
  )
  .component(
    'timeWindowDisplay',
    r2a(withReactQuery(withUIRouter(TimeWindowDisplay)), [])
  ).name;
